import { render, staticRenderFns } from "./formSuccess.vue?vue&type=template&id=71881440&scoped=true&"
import script from "./formSuccess.vue?vue&type=script&lang=js&"
export * from "./formSuccess.vue?vue&type=script&lang=js&"
import style0 from "./formSuccess.vue?vue&type=style&index=0&id=71881440&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71881440",
  null
  
)

export default component.exports